<template>
  <div
    class="flex flex-col place-items-center sm:justify-center min-h-full bg-top bg-fixed px-4 py-10 bg-cover"
    :style="{
      backgroundImage: (bgConfig?.url && `url(${bgConfig?.url})`) || undefined
    }"
  >
    <!-- eslint-disable vue/no-v-html -->
    <slot name="modal" />

    <div>
      <div
        v-if="backOutsideCard || stepDetailText"
        class="flex justify-between mb-3 gap-4"
      >
        <AtomsButtonBack
          v-if="backOutsideCard"
          theme="white"
          @click="handleBack"
        />

        <div
          v-if="stepDetailText"
          class="text-white text-sm/[1.3125rem]"
          v-html="stepDetailText"
        >
        </div>
      </div>

      <atoms-card
        size="none"
        rounded="lg"
        shadow="sm"
        :class="[
          component.card,
          cardClass
        ]"
      >
        <template v-if="$slots.memberhub && !$slots.passowrd">
          <slot name="memberhub" />
        </template>

        <template v-else>
          <div
            v-if="hasSidebar"
            class="bg-white sm:bg-blue-5 rounded-t-lg sm:rounded-tr-none sm:rounded-l-lg px-6 pt-[1.5625rem] sm:pb-[1.5625rem]"
            :class="{
              '!bg-[#effaff] flex flex-col justify-between pb-7 md:!pb-0 relative': abTests?.healthGiftCardLottery
            }"
          >
            <AtomsButtonBack
              v-if="!backOutsideCard"
              class="mb-[1.09375rem] sm:mb-[4.5625rem]"
              :class="{
                'sm:!mb-6': abTests?.healthGiftCardLottery
              }"
              @click="handleBack"
            />

            <div
              class="hidden sm:block"
              :class="{
                '!block': abTests?.healthGiftCardLottery
              }">
              <slot name="sidebar"></slot>
            </div>
            <div v-if="abTests?.healthGiftCardLottery" class="absolute md:relative bottom-0 right-4 md:right-0">
              <img
                width="305"
                height="206"
                src="/icons/top-couple.svg"
                alt="top-couple.svg"
                class="mx-auto w-full h-auto hidden md:block"
              />
              <img
                width="87"
                height="100"
                src="/icons/top-single.svg"
                alt="top-single.svg"
                class="md:hidden"
              />
            </div>
          </div>

          <div
            class="bg-white px-6 pb-10 pt-8 sm:py-8"
            :class="{
              'rounded-2xl': !hasSidebar,
              'rounded-lg sm:rounded-r-lg': hasSidebar,
              'sm:shadow-sm-3 z-10': abTests?.healthGiftCardLottery
            }"
          >
            <AtomsButtonBack
              v-if="!hasSidebar && !backOutsideCard"
              class="mb-4 lg:mt-0"
              @click="handleBack"
            />

            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="abTests?.healthDataSecuritySignaling"
              class="mb-6"
            >
              <AtomsHeadline
                class="pl-3"
              >
                <p class="font-bold text-lg mb-1">
                  We need just a few more details!
                </p>
                <div class="flex gap-x-1 items-center">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4"
                      y="13.6"
                      width="17.6"
                      height="13.6"
                      fill="#F4F5F7"
                    />
                    <rect
                      x="4"
                      y="13.6"
                      width="14.4"
                      height="13.6"
                      fill="#D1D7DF"
                    />
                    <path d="M12.8 17.3334C12.3941 17.3287 11.9964 17.4484 11.6606 17.6765C11.3248 17.9046 11.0669 18.2301 10.9216 18.6092C10.7764 18.9882 10.7508 19.4027 10.8482 19.7968C10.9457 20.1909 11.1615 20.5457 11.4667 20.8134V22.6667C11.4667 23.0204 11.6072 23.3595 11.8572 23.6096C12.1073 23.8596 12.4464 24.0001 12.8 24.0001C13.1536 24.0001 13.4928 23.8596 13.7428 23.6096C13.9929 23.3595 14.1334 23.0204 14.1334 22.6667V20.8134C14.4385 20.5457 14.6544 20.1909 14.7518 19.7968C14.8493 19.4027 14.8237 18.9882 14.6784 18.6092C14.5332 18.2301 14.2753 17.9046 13.9394 17.6765C13.6036 17.4484 13.206 17.3287 12.8 17.3334ZM19.4667 12.0001V9.33341C19.4667 7.5653 18.7643 5.86961 17.5141 4.61937C16.2638 3.36913 14.5681 2.66675 12.8 2.66675C11.0319 2.66675 9.33623 3.36913 8.08598 4.61937C6.83574 5.86961 6.13336 7.5653 6.13336 9.33341V12.0001C5.0725 12.0001 4.05508 12.4215 3.30493 13.1717C2.55479 13.9218 2.13336 14.9392 2.13336 16.0001V25.3334C2.13336 26.3943 2.55479 27.4117 3.30493 28.1618C4.05508 28.912 5.0725 29.3334 6.13336 29.3334H19.4667C20.5276 29.3334 21.545 28.912 22.2951 28.1618C23.0453 27.4117 23.4667 26.3943 23.4667 25.3334V16.0001C23.4667 14.9392 23.0453 13.9218 22.2951 13.1717C21.545 12.4215 20.5276 12.0001 19.4667 12.0001ZM8.80003 9.33341C8.80003 8.27255 9.22145 7.25513 9.9716 6.50499C10.7217 5.75484 11.7392 5.33341 12.8 5.33341C13.8609 5.33341 14.8783 5.75484 15.6285 6.50499C16.3786 7.25513 16.8 8.27255 16.8 9.33341V12.0001H8.80003V9.33341ZM20.8 25.3334C20.8 25.687 20.6596 26.0262 20.4095 26.2762C20.1595 26.5263 19.8203 26.6667 19.4667 26.6667H6.13336C5.77974 26.6667 5.4406 26.5263 5.19055 26.2762C4.9405 26.0262 4.80003 25.687 4.80003 25.3334V16.0001C4.80003 15.6465 4.9405 15.3073 5.19055 15.0573C5.4406 14.8072 5.77974 14.6667 6.13336 14.6667H19.4667C19.8203 14.6667 20.1595 14.8072 20.4095 15.0573C20.6596 15.3073 20.8 15.6465 20.8 16.0001V25.3334Z" fill="#193560" />
                    <path
                      d="M22.7892 3.17608L16.8781 5.6928C16.4157 5.88965 16.1156 6.34361 16.1156 6.84613V9.73591C16.1156 10.3916 16.1912 11.0451 16.3408 11.6835C16.91 14.111 18.2686 16.281 20.2038 17.8532L23.0267 20.1466L25.7104 17.9257C27.6647 16.3083 29.0145 14.0774 29.5403 11.5956C29.6632 11.0153 29.7252 10.4237 29.7252 9.83048V6.83591C29.7252 6.33857 29.4312 5.88827 28.9758 5.68825L23.2631 3.17878C23.1123 3.11253 22.9408 3.11155 22.7892 3.17608Z"
                      :fill="semanticColorLookup('states.success.default')"
                      stroke="white"
                      stroke-width="2.6861"
                    />
                    <path d="M22.7892 3.17608L16.8781 5.6928C16.4157 5.88965 16.1156 6.34361 16.1156 6.84613V9.81986C16.1156 10.4198 16.1848 11.0177 16.3217 11.6018C16.9032 14.0823 18.2915 16.2996 20.269 17.9062L23.0267 20.1466L25.6506 17.9751C27.6437 16.3257 29.0202 14.0506 29.5563 11.5198C29.6686 10.9899 29.7252 10.4497 29.7252 9.90801V6.83591C29.7252 6.33857 29.4312 5.88827 28.9758 5.68825L23.2631 3.17878C23.1123 3.11253 22.9408 3.11155 22.7892 3.17608Z" :fill="semanticColorLookup('states.success.default')" />
                    <path d="M21.5326 14.9841L18.6973 12.2006L19.9581 10.9628L21.5326 12.5129L25.9424 8.17932L27.2033 9.41712L21.5326 14.9841Z" fill="white" />
                  </svg>
                  <p class="text-sm">
                    Your data is securely stored and protected
                  </p>
                </div>
              </AtomsHeadline>
            </div>

            <p
              v-else
              class="font-bold text-xl mb-4"
              v-html="formTitle"
            >
            </p>

            <form
              class="flex flex-col"
              @submit.prevent="handleSubmit"
            >
              <ul
                class="gap-4 grid grid-cols-[121px,1fr]"
                :class="[
                  formListClass
                ]"
              >
                <li
                  ref="fullName"
                  class="col-span-2"
                >
                  <AtomsInput
                    v-model="formModel.full_name"
                    name="full_name"
                    label="Full name"
                    data-testid="name-input"
                    :placeholder="placeholder?.full_name ?? 'Full Name'"
                    :error-message="validation.full_name.errorMessage"
                    :is-success="validation.full_name.isSuccess"
                    @focusout="handleValidateForm('full_name')"
                  />
                </li>

                <li
                  ref="email"
                  class="col-span-2"
                >
                  <AtomsInput
                    v-model="formModel.email"
                    name="email"
                    label="Your Email"
                    data-testid="email-input"
                    :placeholder="placeholder?.email ?? 'Your Email'"
                    :error-message="validation.email.errorMessage"
                    :is-success="validation.email.isSuccess"
                    @focusout="handleValidateForm('email')"
                  />
                </li>

                <li
                  v-if="hasAreacode"
                  ref="areacode"
                >
                  <AtomsInput
                    v-model="formModel.areacode"
                    name="areacode"
                    label="Area code"
                    :placeholder="placeholder?.areacode ?? 'Code (+61)'"
                    :error-message="validation.areacode.errorMessage"
                    :is-success="validation.areacode.isSuccess"
                    @update="handleValidateForm('areacode')"
                  />
                </li>

                <li
                  v-if="hasPhone"
                  ref="phone"
                  :class="{
                    'col-span-2': !hasAreacode
                  }"
                >
                  <AtomsInput
                    v-model="formModel.phone"
                    name="phone"
                    label="Phone number"
                    model-type="number"
                    data-testid="phone-input"
                    :placeholder="placeholder?.phone ?? 'Phone number'"
                    :maxlength="phoneMaxlength"
                    :error-message="validation.phone.errorMessage"
                    :is-success="validation.phone.isSuccess"
                    :mobile-keyboard-type="abTests?.healthNumericalKeyboard ? 'numeric' : 'text'"
                    @focusout="handleValidateForm('phone')"
                  />
                </li>

                <li
                  v-if="hasPassword"
                  ref="password"
                  class="col-span-2"
                >
                  <AtomsInput
                    v-model="formModel.password"
                    name="password"
                    label="Password"
                    type="password"
                    :placeholder="placeholder?.password ?? 'Password'"
                    :error-message="validation.password.errorMessage"
                    :is-success="validation.password.isSuccess"
                    @update="handleValidateForm('password')"
                  />

                  <MoleculesFormPasswordMeter
                    v-if="!_isEmpty(formModel.password)"
                    :schema-obj="passwordMeter"
                  />
                </li>
              </ul>

              <slot name="note" />
              <slot name="schedule" />

              <div
                v-if="!!$slots.agreement"
                :class="[
                  switchAgreementButton ? 'order-2 mt-6' : 'order-1 mt-4'
                ]"
              >
                <slot name="agreement" />
              </div>

              <atoms-button
                :id="strToKebabCase(
                  vertical
                    ? `${vertical} get your quotes`
                    : ''
                )"
                class="w-full lg:w-auto mx-auto justify-center mt-5"
                size="large"
                type="submit"
                :class="[
                  buttonConfig?.class,
                  switchAgreementButton ? 'order-1' : 'order-2'
                ]"
                :full="buttonConfig?.full || false"
                :has-icon="buttonConfig?.hasIcon || false"
                enable-tracking
              >
                {{ buttonConfig?.label || 'Get your quotes' }}
              </atoms-button>
            </form>
            <slot name="footer" />
          </div>
        </template>
      </atoms-card>
    </div>
  </div>
</template>

<script setup>
import _isEmpty from 'underscore/cjs/isEmpty.js'
import _omit from 'underscore/cjs/omit.js'

import { storeToRefs } from 'pinia'

import {
  GENERATE_FORM_MODEL_TEST,
  handleScrollToError
} from '~/helpers/formfunnel.helpers'

import {
  COUNTRIES
} from '~/constants/country.constants'

import memberhubConstants from '~/constants/memberhub.constants'

import {
  validateFullname,
  emailValidator,
  phoneNumberValidator,
  areacodeValidator,
  passwordValidator
} from '~/helpers/validator.js'

defineOptions({
  name: 'LayoutsFormDetails'
})

const props = defineProps({
  bgConfig: {
    type: Object,
    default: () => ({
      url: '',
      color: ''
    }),
    validator: obj => 'url' in obj
  },

  stepMainUrl: {
    type: String,
    default: '',
    required: true
  },

  backUrl: {
    type: String,
    default: ''
  },

  backButtonFunction: {
    type: Function,
    default: null
  },

  backOutsideCard: {
    type: Boolean,
    default: false
  },

  stepDetailText: {
    type: String,
    default: null
  },

  formTitle: {
    type: String,
    default: ''
  },

  formListClass: {
    type: [String, Object],
    default: ''
  },

  placeholder: {
    type: Object,
    default: () => ({})
  },

  phoneMaxlength: {
    type: Number,
    default: 10
  },

  hasAreacode: {
    type: Boolean,
    default: false
  },

  hasPassword: {
    type: Boolean,
    default: false
  },

  buttonConfig: {
    type: Object,
    default: () => {
      return {
        label: 'Get your quotes',
        class: '',
        hasIcon: false
      }
    },
    validtor: obj => 'label' in obj && 'class' in obj && 'hasIcon' in obj
  },

  abTests: {
    type: Object,
    default: () => ({})
  },

  submit: {
    type: Function,
    default: null
  },

  errorMap: {
    type: Object,
    default: () => ({})
  },

  switchAgreementButton: {
    type: Boolean,
    default: false
  },

  disablePhoneValidation: {
    type: Boolean,
    default: false
  },

  optionalPhone: {
    type: Boolean,
    default: false
  },

  prefillForm: {
    type: Boolean,
    default: false
  },

  trackingTitle: {
    type: String,
    default: ''
  },

  formNoSteps: {
    type: Boolean,
    default: false
  },

  form: {
    type: Object,
    default: () => ({}),
    required: true
  },

  hasPhone: {
    type: Boolean,
    default: true
  },

  cardClass: {
    type: String,
    default: ''
  }
})

defineExpose({
  backUrl: props.backUrl
})

const $router = useRouter()
const $slots = useSlots()

const { $tracking } = useNuxtApp()

const layoutStore = useLayoutsStore()
const { vertical, navigation, footer } = storeToRefs(layoutStore)

const userStore = useUserStore()
const { getUserProfile } = storeToRefs(userStore)

const formModel = ref()
const _model = computed(() => flattenObj(props.form, 1))

const validation = ref({})
const passwordMeter = ref({
  error: {
    errorObj: {}
  }
})

onMounted(async () => {
  navigation.value.layout = 'minimal'
  footer.value.show = false

  await nextTick()
  await wait(100)

  if (
    vertical.value === 'Health Insurance' &&
    props.form.step1 &&
    (
      props.form.step1.hasOwnProperty('full_name') || 
      props.form.step1.hasOwnProperty('phone') || 
      props.form.step1.hasOwnProperty('email')
    )
  ) {
    handlePrefillForm({ given_name: props.form.step1.full_name || '', phone_number: props.form.step1.phone || '', email: props.form.step1.email || '' })
  }
  if (props.prefillForm && vertical.value == 'Car Insurance') {
    handlePrefillForm({ given_name: props.form.given_name || '', phone_number: props.form.phone_number || '', email: props.form.email || '' })
  }
})

onBeforeUnmount(() => {
  navigation.value.layout = 'default'
  footer.value.show = true
})

const hasSidebar = computed(() => !!$slots.sidebar)

const _errorMap = computed(() => {
  const _default = {
    email: 'Please enter a valid email address.',
    full_name: 'Full name field is required.',
    phone: 'Please enter a valid number.',
    password: _isEmpty(formModel.value.password)
      ? 'Password is required.'
      : 'Must be a valid password.',
    postcode: 'Please enter valid postcode'
  }

  return {
    ..._default,
    ...(props?.errorMap ?? {})
  }
})

const component = computed(() => {
  const card = (() => {
    const maxWidth = getKey(hasSidebar.value, {
      false: 'max-w-[23.9375rem]',
      true: 'max-w-wrapper-sm'
    })

    return getKey(hasSidebar.value, {
      false: 'w-full my-auto',
      true: 'grid sm:grid-cols-[22.0625rem,1fr] w-full'
    }) + ` ${maxWidth}`
  })()

  return {
    card
  }
})

watch(() => getUserProfile.value, user => {
  handlePrefillForm(user)
})

function validatePreviousSteps () {
  const formStepsValue = props.formNoSteps
    ? props.form
    : _omit(props.form, value => !isObject(value))

  if (_isEmpty(formStepsValue) && props.stepMainUrl) {
    navigateTo(props.stepMainUrl, {
      redirectCode: 301
    })
  }
}
validatePreviousSteps()

async function handleModels () {
  const formArr = [
    'full_name',
    'email'
  ]

  if (props.hasPhone) {
    formArr.push('phone')
  }

  if (props.hasAreacode) {
    formArr.push('areacode')
  }

  if (props.hasPassword) {
    formArr.push('password')
  }

  formModel.value = GENERATE_FORM_MODEL_TEST({
    form: formArr
  })

  validation.value = GENERATE_FORM_MODEL_TEST({
    form: formArr,
    type: 'validation'
  })

  await nextTick()

  /**
   * prefill country code
   */
  const country = _model.value?.country_of_citizenship
  if (props.hasAreacode && country) {
    formModel.value.areacode = _model.value.already_in_australia === 'Yes'
      ? '+61'
      : country?.phoneCode ?? ''
  }
}
handleModels()

watch(() => props.abTests?.healthEmailValidation, async (newValue, oldValue) => {
  if (newValue !== oldValue) {
    await handleModels()
  }
})
handlePrefillForm(getUserProfile.value)

function handlePrefillForm (user) {
  const areacode = (() => {
    const coc = _model.value?.country_of_citizenship

    if (!coc) {
      return ''
    }

    const country = COUNTRIES.find(item => item.name === coc)

    return _model.value?.already_in_australia === 'Yes'
      ? '+61'
      : (country?.phoneCode ?? '')
  })()

  if (_isEmpty(user)) {
    return
  }

  try {
    if (props?.prefillForm) {
      formModel.value.full_name = !_isEmpty(user)
        ? `${user?.given_name || ''} ${user?.family_name || ''}`.trim()
        : (props.form?.full_name || '')
      formModel.value.email = user?.email || props.form?.email || ''
      formModel.value.phone = user?.phone_number || props.form?.phone || ''
    } else {
      const tempUser = props?.form?.user

      formModel.value.full_name = `${user?.given_name || ''} ${user?.family_name || ''}`.trim() || tempUser?.full_name
      formModel.value.email = user?.email || tempUser?.email
      formModel.value.phone = user?.phone_number || tempUser?.phone
    }

    if (props.hasAreacode) {
      formModel.value.areacode = areacode
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error)
  }
}

function handleBack ($event) {
  if (
    props.backButtonFunction &&
    typeof props.backButtonFunction === 'function'
  ) {
    props.backButtonFunction()

    return
  }

  if (props.backUrl) {
    $tracking.click($event)
    $router.push(props.backUrl)
  } else {
    $router.go(-1)
  }
}

function handleValidateForm (key) {
  const validateMap = (tempKey, tempValue) => {
    const map = getKey(tempKey, {
      full_name: value => validateFullname(value),
      email: value => emailValidator(value),
      phone: value => {
        const areaCode = formModel.value?.areacode ?? ''

        if (props.optionalPhone && !value) {
          return { valid: true }
        }

        if (!props.hasPhone) {
          formModel.value.phone = ''
          return { valid: true }
        }

        if (!value) {
          return phoneNumberValidator(value)
        }

        if (props.hasAreacode && areaCode === '+61') {
          return phoneNumberValidator(value, true)
        }

        if (props.disablePhoneValidation) {
          return !!(value.length < 14)
        }

        return phoneNumberValidator(value)
      },
      areacode: value => areacodeValidator(value),
      password: value => {
        const result = validatePassword(value)
        passwordMeter.value.error.status = !result.valid
        passwordMeter.value.error.errorObj = result

        return result?.valid
      },
      postcode: value => {
        if (!value) {
          return false 
        }

        return { valid: true }
      }
    })

    if (map) {
      return map?.(tempValue)
    }
  }

  const value = formModel.value[key]

  if (key && ![null, undefined].includes(value)) {
    const isValid = validateMap(key, value)

    validation.value[key] = {
      isSuccess: (isValid?.valid ?? isValid),
      errorMessage: (isValid?.valid ?? isValid)
        ? ''
        : isValid?.errorMessage ?? _errorMap.value[key]
    }

    return
  }

  for (const formKey in formModel.value) {
    if (Object.hasOwnProperty.call(formModel.value, formKey)) {
      const formValue = formModel.value[formKey]
      const validated = validateMap(formKey, formValue)

      validation.value[formKey] = {
        isSuccess: validated?.valid ?? validated,
        errorMessage: validated?.valid ?? validated
          ? ''
          : validated?.errorMessage ?? _errorMap.value[formKey]
      }
    }
  }
}

const emit = defineEmits([
  'validationError'
])

function validatePassword (value) {
  const eightCharCheck = passwordValidator(value, /^.{8,}$/)
  const sixCharCheck = passwordValidator(value, /^.{6,}$/)
  const lowercaseCheck = passwordValidator(value, /[a-z]/)
  const uppercaseCheck = passwordValidator(value, /[A-Z]/)
  const numberCheck = passwordValidator(value, /\d/)
  // eslint-disable-next-line no-useless-escape
  const specialCharCheck = passwordValidator(value, /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/)

  const result = {
    passwordMeterRequires: []
  }

  if (!eightCharCheck) {
    result.passwordMeterRequires.push(memberhubConstants.PASSWORD_METER_REQUIRED_KEYS.MIN_LENGTH)
  }

  if (!lowercaseCheck) {
    result.passwordMeterRequires.push(memberhubConstants.PASSWORD_METER_REQUIRED_KEYS.LOWERCASE)
  }

  if (!uppercaseCheck) {
    result.passwordMeterRequires.push(memberhubConstants.PASSWORD_METER_REQUIRED_KEYS.UPPERCASE)
  }

  if (!specialCharCheck) {
    result.passwordMeterRequires.push(memberhubConstants.PASSWORD_METER_REQUIRED_KEYS.SPECIAL_CHAR)
  }

  if (!numberCheck) {
    result.passwordMeterRequires.push(memberhubConstants.PASSWORD_METER_REQUIRED_KEYS.NUMBER)
  }

  const conditionsSatisfied = [
    lowercaseCheck,
    uppercaseCheck,
    numberCheck,
    specialCharCheck
  ].filter(Boolean).length

  if (eightCharCheck && conditionsSatisfied === 4) {
    result.valid = true
    result.passwordMeter = memberhubConstants.PASSWORD_METER.STRONG
    result.passwordMeterRequires = []
  } else if (eightCharCheck && conditionsSatisfied >= 3) {
    result.valid = true
    result.passwordMeter = memberhubConstants.PASSWORD_METER.GOOD
  } else if (sixCharCheck && conditionsSatisfied >= 3) {
    result.valid = false
    result.passwordMeter = memberhubConstants.PASSWORD_METER.WEAK
  } else {
    result.passwordMeter = memberhubConstants.PASSWORD_METER.POOR
    result.valid = false
  }

  return result
}

async function handleSubmit () {
  await handleValidateForm()

  const hasError = await handleScrollToError(validation.value)

  if (hasError) {
    emit('validationError', true)
    return
  }

  props.submit(formModel.value)
}
</script>
